/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishname3Inputs */

const en_menueditordishname3 = /** @type {(inputs: Menueditordishname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dish`)
};

const de_menueditordishname3 = /** @type {(inputs: Menueditordishname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gericht`)
};

/**
* | output |
* | --- |
* | "Dish" |
*
* @param {Menueditordishname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishname3 = /** @type {((inputs?: Menueditordishname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishname3(inputs)
	return de_menueditordishname3(inputs)
});
export { menueditordishname3 as "menuEditorDishName" }